import { BaseViewModel } from '@apis/model/BaseViewModel';
import { BaseResponse } from '@ul/api/lib/models/BaseResponse';

export const toBaseViewModel = (response: BaseResponse): BaseViewModel => {
    const { success, responseCode } = response;
    return {
        success,
        responseCode,
    };
};
